/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutboundExecutionResult } from './OutboundExecutionResult';
import {
    OutboundExecutionResultFromJSON,
    OutboundExecutionResultFromJSONTyped,
    OutboundExecutionResultToJSON,
    OutboundExecutionResultToJSONTyped,
} from './OutboundExecutionResult';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface OutboundSyncResponse
 */
export interface OutboundSyncResponse {
    /**
     * 
     * @type {OutboundExecutionResult}
     * @memberof OutboundSyncResponse
     */
    data?: OutboundExecutionResult;
    /**
     * 
     * @type {string}
     * @memberof OutboundSyncResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof OutboundSyncResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof OutboundSyncResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof OutboundSyncResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the OutboundSyncResponse interface.
 */
export function instanceOfOutboundSyncResponse(value: object): value is OutboundSyncResponse {
    return true;
}

export function OutboundSyncResponseFromJSON(json: any): OutboundSyncResponse {
    return OutboundSyncResponseFromJSONTyped(json, false);
}

export function OutboundSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OutboundExecutionResultFromJSON(json['data']),
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function OutboundSyncResponseToJSON(json: any): OutboundSyncResponse {
    return OutboundSyncResponseToJSONTyped(json, false);
}

export function OutboundSyncResponseToJSONTyped(value?: OutboundSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OutboundExecutionResultToJSON(value['data']),
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

